var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.21 72.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.4,68.53l-.56.18c-1.68.54-3.52-.61-4.11-2.54L.29,2.33C.08,1.63.71.81,1.7.49l.33-.11c.99-.32,1.98-.02,2.23.67l21.97,63.01c.66,1.9-.15,3.92-1.82,4.46Z",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.81,68.53l.56.18c1.68.54,3.52-.61,4.11-2.54L76.91,2.33c.21-.7-.42-1.53-1.4-1.85l-.33-.11c-.99-.32-1.98-.02-2.23.67l-21.97,63.01c-.66,1.9.15,3.92,1.82,4.46Z",
    style: {
      fill: "#615b67",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.45,
    cy: 51.55,
    rx: 3.29,
    ry: 7.01,
    transform: "translate(-14.65 7.93) rotate(-17.5)",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.56,
    cy: 51.55,
    rx: 7.01,
    ry: 3.29,
    transform: "translate(-8.21 91.9) rotate(-72.5)",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 68.04,
    width: 76.71,
    height: 4,
    rx: 2,
    ry: 2,
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 52.13,
    width: 76.71,
    height: 17.23,
    rx: 2,
    ry: 2,
    style: {
      fill: "#615b67"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 52.13,
    width: 76.71,
    height: 17.23,
    rx: 2,
    ry: 2,
    style: {
      fill: "none",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.91,
    y: 55.19,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.54,
    y: 55.19,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.27,
    y: 55.19,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.96,
    y: 55.19,
    width: 7.69,
    height: 1.97,
    style: {
      fill: "#fff",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.68,
    y: 55.19,
    width: 9.2,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.23,
    y: 55.19,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 55.19,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.65,
    y: 55.19,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#fec75f",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.67,
    y: 55.19,
    width: 3.02,
    height: 1.97,
    style: {
      fill: "#77acdd",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.91,
    y: 61.93,
    width: 1.97,
    height: 1.97,
    rx: 0.99,
    ry: 0.99,
    style: {
      fill: "#67c189",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.e23c4d268d7321bdfdce7cf1622fbbc1.svg";
export { ForwardRef as ReactComponent };